import { createComponent } from '@carvana/merch-components';

export const SectionTitle = createComponent('div', {
  className: 'text-blue-6 tl-header-xl'
});

export const SectionSubtitle = createComponent('div', {
  className: '!font-normal !normal-case text-grey-5 tl-label-l'
});

export const GridContent = createComponent('div', {
  className:
    'grid w-full grid-cols-1 gap-24 m:grid-cols-2 m:gap-16 l:grid-cols-4'
});

export const ActionBanner = createComponent('div', {
  className: 'flex flex-col items-start'
});

export const ImgWrapper = createComponent('div', {
  className: 'h-[218px] w-full m:h-[230px] m:h-auto l:h-[180px]'
});

export const BannerImg = createComponent('img', {
  className: 'h-full w-full rounded-lg object-cover'
});

export const BannerTitle = createComponent('div', {
  className: 'text-blue-6 tl-header-m'
});

export const BannerSubtitle = createComponent('div', {
  className: 'mt-8 text-grey-5 tl-body-m'
});
